<template>
  <div class="sld_login">
    <div class="sld_login_header">
      <div class="content">
        <router-link tag="a" class="l_logo" :to="`/index`">
          <img
            class="img"
            :src="configInfo.main_site_logo"
            :onerror="defaultImg"
            alt
          />
        </router-link>
        <div class="r_register_wrap">
          {{ L["已有账号？"] }}
          <a
            href="javascript:void(0)"
            class="go_register_btn"
            @click="goToPage('/login')"
          >
            {{ L["去登录"] }}
          </a>
        </div>
      </div>
    </div>
    <!-- 注册页面 -->
    <div class="content">
        <div class="list" @click="goToPage('register2')" style="margin-top:50px;background:#FF6B01">
            <div>
                <img src="../../../assets/geren.png" alt="">
            </div>
            <div>
                I am a Cross-border Buyer
            </div>
            <div>
                <img src="../../../assets/md-keyboard_arrow_right@1x.png" alt="">
            </div>
        </div>
        <div class="list" style="background:#103B8A" @click="hreftwo">
            <div>
                <img src="../../../assets/qiye.png" alt="">
            </div>
            <div>
                I am a Manufacturer
            </div>
            <div>
                <img src="../../../assets/md-keyboard_arrow_right@1x.png" alt="">
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { ref, getCurrentInstance, onMounted, } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
export default {
  name: "Register",
  setup() {
    const store = useStore();
    const agreeFlag = ref(false); //同意注册协议标识，默认不同意
    const list = ref([]); 
    const select = ref("");
    const select2 = ref("");
    const name2 = ref("");
    const email = ref("");
    const list2 = ref([]); 
    const name = ref(""); //用户名
    const errorMsg = ref(); //错误提示
    const password = ref(""); //密码
    const imgCode = ref(""); //图形验证码
    const quemima = ref(""); //确认密码
    const tel = ref(""); //手机号码
    const telyanzheng = ref(""); //手机验证码
    const sex = ref(0); //性别

    const yearArr = ref(
      Array.from({ length: 80 }, (v, k) => k).map(
        (item) => new Date().getFullYear() - item
      )
    ); //生成年份数组-80年间隔
    const year = ref(""); //当前年份
    const monthArr = ref(
      ref(Array.from({ length: 12 }, (v, k) => k).map((item) => 12 - item))
    ); //生成当月的月数
    const month = ref(""); //当前月分
    let d = new Date(year.value, month.value, 0).getDate(); //生成设置月分的当月天数
    const dayArr = ref(
      Array.from({ length: d }, (v, k) => k).map((item) => item + 1)
    ); //生成当月天数数组
    const day = ref(""); //当前天

    const router = useRouter();
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const countDownM = ref(0); //短信验证码倒计时
    const timeOutId = ref(0); //定时器的返回值
    const showCodeImg = ref(""); //图形验证码图片
    const imgCodeKey = ref(""); //图形验证码的key
    const configInfo = ref(store.state.configInfo);
    const defaultImg = ref(
      'this.src="' + require("../../../assets/common_top_logo.png") + '"'
    );
    const defaultBgImg = ref(
      'this.src="' + require("../../../assets/login_bg.png") + '"'
    );
    const isShow = ref(false);
    //获取图形验证码
    const getImgCode = () => {
      proxy.$get("/v3/captcha/common/getCaptcha", {}).then((res) => {
        if (res.state == 200) {
          isShow.value = true;
          // 后台做判断判断返回回来的数据用户输入的数据是否相等
          showCodeImg.value = "data:image/png;base64," + res.data.captcha;
          imgCodeKey.value = res.data.key;
        }
      });
    };
    //获取短信验证码短信
    const getSmsCode = () => {
      if (countDownM.value) {
        ElMessage("验证码失效请重新获取");
        return false;
      }
      let checkMobile = proxy.$checkMobile(tel.value);
    //   let checkImgCode = proxy.$checkImgCode(imgCode.value);
      console.log(checkMobile);
      if (checkMobile !== true) {
        ElMessage(checkMobile); //提示请输入手机号
      }  else {
        let param = {};
        param.mobile = tel.value;
        // param.verifyCode = imgCode.value;
        param.type = 'wxAuth';
        // param.type = imgCodeKey.value;
        proxy.$get("v3/msg/front/commons/smsCode", param).then((res) => {
          if (res.state == 200) {
            console.log(res);
            countDownM.value = 60;
            if (countDownM.value == 0) {
              clearInterval(timeOutId.value);
            } else {
              timeOutId.value = setInterval(() => {
                countDownM.value--;
                console.log(countDownM.value);
                if (countDownM.value == 0) {
                  clearInterval(timeOutId.value);
                }
              }, 1000);
            }
          } else {
            //提示错误
            // getImgCode();
            ElMessage(res.msg);
          }
        });
      }
    };

    const login = () => {
    //   let month1 = month.value;
    //   let day1 = day.value;
    //   if (month1 <= 9) {
    //     month1 = "0" + month.value;
    //   }
    //   if (day1 <= 9) {
    //     day1 = "0" + day.value;
    //   }
      let param = {
        smsCode: telyanzheng.value, //手机验证码
        confirmPassword: quemima.value, //确认密码
        loginPwd: password.value, //密码
        memberMobile: tel.value, //手机
        memberName: name.value, //用户名
        memberEmail: email.value,
        ip: '',
        memberTrueName: name2.value, //姓名
        countryCode: select.value.substring(0,select.value.indexOf(',')),
        provinceCode: select2.value.substring(0,select2.value.indexOf(',')),
        areaInfo: select.value.substring(select.value.indexOf(',') + 1) + " " + select2.value.substring(select2.value.indexOf(',') + 1),
        // verifyCode: imgCode.value, //图形验证码
        // verifyKey: imgCodeKey.value, //图形验证码key
        // gender: sex.value, //性别
        // memberBirthday: year.value + "-" + month1 + "-" + day1, //生日
      };
      console.log(param);

      // return false
      if (
        param.smsCode == "" ||
        param.confirmPassword == "" ||
        param.loginPwd == "" ||
        param.memberMobile == "" ||
        param.memberName == "" ||
        param.memberEmail == "" ||
        param.memberTrueName == "" ||
        param.countryCode == "" ||
        param.provinceCode == "" ||
        param.areaInfo == ""
      ) {
        ElMessage("请补全信息");
        return false;
      }
      if (!agreeFlag.value) {
        ElMessage("请同意用户注册协议及隐私政策");
        return false;
      }
      if (param.loginPwd.value != param.confirmPassword.value) {
        ElMessage("确认密码和密码不相同");
        return false;
      }

      //如果未登录vuex中有购物车数据，需同步到该用户
      let cartInfo = [];
      let cartListData = store.state.cartListData;
      if (JSON.stringify(cartListData) != "{}") {
        cartListData.storeCartGroupList.map((cartListItem) => {
          cartListItem.promotionCartGroupList.map((promotItem) => {
            promotItem.cartList.map((cartItem) => {
              cartInfo.push({
                productId: cartItem.productId,
                buyNum: cartItem.buyNum,
              });
            });
          });
        });
      }
      param.cartInfo = JSON.stringify(cartInfo);
      console.log(param);
      //请求接口
      proxy.$post("v3/frontLogin/oauth/register", param).then((res) => {
        if (res.state == 200) {
          //将用户信息存缓存，并跳转到首页
          localStorage.setItem("access_token", res.data.access_token);
          localStorage.setItem("refresh_token", res.data.refresh_token);
          localStorage.setItem("time", new Date().getTime().toString()); //存储refresh_token更新时间
          //获取用户信息，并同步信息到vuex
          proxy.$get("/v3/member/front/member/getInfo").then((res) => {
            if (res.state == 200) {
              //清空购物车store
              store.commit("updateCartListData", {});
              store.commit("updateMemberInfo", res.data);
              router.back();
            }
          });
        } else {
          //提示错误
          getImgCode();
          ElMessage(res.msg);
        }
      });
    };
    const sey = (sex1) => {
      sex.value = sex1;
    };
    const hreftwo = () => {
      let url = 'https://seller.heronlink.net/base/#/user/login'
      window.open(url,"_blank");

                            
    };
    //清空输入框内容
    const clearInputVal = (type) => {
      if (type == "name") {
        name.value = "";
      } else if (type == "password") {
        password.value = "";
      }
    };
    //是否同意用户注册协议
    const agree = () => {
      agreeFlag.value = !agreeFlag.value;
    };
    // getImgCode();//获取图形验证码
    //通过replace方式跳转页面
    const goToPage = (type) => {
      router.replace({
        path: type,
      });
    };
    const map = () => {
        console.log(111111111)
        let param = {}
        proxy.$get("/v3/system/front/region/list", param).then((res) => {
            list.value = res.data
        })
    }
    const selec = (e) => {
        console.log(e,select.value)
        list2.value = list.value[0].children
    }
    const selec2 = (e) => {
        console.log(e,select2.value)
    }

    onMounted(() => {
      ElMessage("请选择身份进行注册");
      getImgCode();
      map();
      document.body.classList.remove("el-popup-parent--hidden");
    });
    return {
      L,
      login,
      map,
      selec,
      hreftwo,
      selec2,
      select,
      select2,
      name,
      email,
      list2,
      name2,
      password,
      clearInputVal,
      errorMsg,
      getSmsCode,
      countDownM,
      imgCode,
      showCodeImg,
      imgCodeKey,
      getImgCode,
      agreeFlag,
      agree,
      goToPage,
      configInfo,
      defaultImg,
      defaultBgImg,
      quemima,
      list,

      tel,
      telyanzheng,

      isShow,
      sex,
      timeOutId,

      yearArr,
      year,
      monthArr,
      month,
      dayArr,
      day,
      sey,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../../style/register.scss";

.el-popup-parent--hidden {
  overflow: visible;
}
.beijing {
  width: 100%;
  height: 100vh;
  background-color: #eaeef5;
  overflow: hidden;
}
.nav {
  width: 1150px;
  height: 100px;
  border-bottom: 2px solid #D4D4D4;
  margin: 0 auto;
}
.nav_center{
    width: 170px;
    height: 100%;
    margin: 0 auto;
    text-align: center;
    border-bottom: 3px solid red;
}
.nav_center img{
    height: 40px;
    margin-top: 20px;
}
.nav_center p{
    text-align: center;
    font-size: 16px;
    color: #FF2506;
}
input {
  color: #888888;
  font-size: 14px !important;
}
#sex {
  input {
    margin-left: 6px;
    margin-top: 0;
    margin-right: 6px;
    vertical-align: sub;
    outline: none;
  }
  .el-radio__label {
    display: inline-block;
    width: 50px !important;
    padding-left: 10px;
  }
}
.set {
  width: 350px;
  display: flex;
  border: 1px solid #f2f2f2;
  margin-left: 10px;
  font-size: 16px;
}
.input_rodio1 {
  margin-left: 20px;
}
.warp {
  width: 1200px;
  height: 800px;
  background-color: #fff;
  margin: 60px auto;
  overflow: hidden;
}
.tbox {
  width: 500px;
  margin: 0 auto;
  // margin-top: 100px;
}
.bb_b {
  margin-left: 20px;
}
.box {
  width: 555px;
  height: 40px;
  // border: 1px solid #000;
  font-size: 20px;
  margin-top: 10px;
  line-height: 40px;
  display: flex;
  position: relative;
}

.wigth {
  width: 120px;
  text-align: right;
  line-height: 40px;
  font-size: 18px;
  position: relative;
}
input {
  //   width: 240px !important;
  margin-left: 10px;
  border: 1px solid #bbbbbb;
  padding: 0 10px;
  border-radius: 5px;
}
select{
    width: 175px;
    padding: 0 10px;
    font-size: 14px;
    border: 1px solid #bbbbbb;
    border-radius: 5px;
}
.input1 {
  width: 350px;
  margin-left: 10px;
  border: 1px solid #bbbbbb;
}
.zize {
  font-size: 16px;
}
.zize1 {
  font-size: 16px;
  margin-left: 60px;
}
.tuxing {
  width: 80px;
  height: 40px;
  background-color: #ccc;
   
  color: #fff;
  // border: 1px solid #888888;
  position: absolute;
  top: 0;
  font-size: 16px;
  right: 75px;
}
.tuxing1 {
  height: 40px;
  background-color: red;
  border: 1px solid #ccc;
  color: #fff;
  position: absolute;
  top: 0;
  right: 75px;
  font-size: 13px;
}
.tuxing2 {
  width: 100px;
  height: 40px;
  border-radius: 5px;
  background-color: red;
  border: 1px solid #ccc;
  text-align: center;
  color: #fff;
  position: absolute;
  top: 0;
  right: 75px;
  font-size: 13px;
}
.span {
  font-size: 12px;
  padding-left: 5px;
}
.b_www {
  width: 100%;
  text-align: center;
}
.b_zhuce {
  width: 200px;
  height: 50px;
  background-color: red;
  color: #fff;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  margin: 0 auto;
}
.ii {
  color: #ec8b52;
  position: absolute;
  top: 5px;
}
#year {
  width: 70px;
  height: 25px;
  line-height: 30px;
  margin-top: 10px;
  border-radius: 3px;
  color: #888888;
  border: 1px solid #888888;
  font-size: 16px;
  margin-left: 10px;
}
#month {
  width: 70px;
  height: 25px;
   border-radius: 3px;
  line-height: 30px;
  color: #888888;
  font-size: 16px;
  border: 1px solid #888888;
  margin-left: 10px;
  margin-top: 10px;
}
#day {
  width: 70px;
  height: 25px;
  line-height: 30px;
    border-radius: 3px;
   border: 1px solid #888888;
  margin-top: 10px;
  color: #888888;

  margin-left: 10px;
  font-size: 16px;
}
.tag_name {
  width: 350px;
  font-size: 16px;
  border: 1px solid #f2f2f2;
  margin-left: 10px;
  color: #888888;
}
.content{
   width: 1200px;
   height: auto;
   margin: 0 auto;
}
.list{
    width: 420px;
    height: 170px;
    margin: 0 auto;
    margin-top: 30px;
}
.list>div{
    float: left;
}
.list>div:nth-child(1){
    height: 170px;
    width: 170px;
}
.list>div:nth-child(2){
    height: 170px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
}
.list>div:nth-child(1) img{
    width: 70%;
    height: 70%;
    margin: 15%;
    border-radius: 170px;
}
.list>div:nth-child(3){
    height: 170px;
    width: 50px;
    float: right;
}
.list>div:nth-child(3) img{
    height: 20%;
    margin-top: 140%;
    width: auto;
}
</style>